
import { OrdersReplacementApiRemoteService } from '../../Services/api/orders-replacement/orders-replacement-service'
import { IPayloadOrderReplacement } from '../../Services/api/orders-replacement/orders-replacement.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateOrdersReplacementUseCase
implements IFormUsecase<IPayloadOrderReplacement, void> {
  constructor (private readonly OrdersReplacementApi: OrdersReplacementApiRemoteService) {}
    
  public async handle (
    data: IPayloadOrderReplacement
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrdersReplacementApi.create(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
